import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  field: {
    flex: "1 1 404.45px",
    minWidth: 404.45,
    "& .MuiOutlinedInput-root": {
      height: 40,
    },
  },
  search: {
    "& .MuiSvgIcon-root": {
      color: theme.palette.action.active,
      transition: theme.transitions.create("color"),
    },
    "&:focus-within .MuiSvgIcon-root": {
      color: theme.palette.primary.main,
    },
  },
}));


